var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseHamburger',{staticClass:"sidebar-hamburger--css"},[_c('div',{staticClass:"sidebar-hamburger--css--toggle"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"line"}),_c('div',{staticClass:"line"})])])}
var staticRenderFns = []

export { render, staticRenderFns }